﻿
/**
 * Collapses an element
 * @param {Node} element Target element
 */
export const collapse = element => {
  const sectionHeight = element.scrollHeight
  const elementTransition = element.style.transition
  element.style.transition = ''

  window.requestAnimationFrame(function () {
    element.style.height = sectionHeight + 'px'
    element.style.transition = elementTransition

    window.requestAnimationFrame(function () {
      element.style.height = 0 + 'px'
    })
  })

  element.setAttribute('data-collapsed', 'true')
}

/**
 * Expands an element
 * @param {any} element Target element
 */
export const expand = element => {
  const sectionHeight = element.scrollHeight

  element.style.height = sectionHeight + 'px'

  element.setAttribute('data-collapsed', 'false')
}

/**
 * Read a file and set it as node src
 *
 * @param {Node} node
 * @param {File} file
 * @param {Number} maxWidth
 * @param {Number} maxHeight
 */
export const createImg = async (node, file, maxWidth, maxHeight) => {
  try {
    const resizedImage = await resizeImage(file, maxWidth, maxHeight)
    node.src = resizedImage
  } catch (err) {
    console.error(err)
  }
}

export const isNullOrWhitespace = input => {
  return typeof input === 'undefined' || input == null || input.replace(/\s/g, '').length < 1
}

export const setDateTime = (isUnpublish = false, value = '') => {
  const now = value === '' ? new Date() : new Date(value)
  const utcString = now.toISOString().substring(0, 19)
  const year = isUnpublish ? now.getFullYear() + 1 : now.getFullYear()
  const month = now.getMonth() + 1
  const day = now.getDate()
  const hour = now.getHours()
  const minute = now.getMinutes()
  const localDatetime =
    year +
    '-' +
    (month < 10 ? '0' + month.toString() : month) +
    '-' +
    (day < 10 ? '0' + day.toString() : day) +
    'T' +
    (hour < 10 ? '0' + hour.toString() : hour) +
    ':' +
    (minute < 10 ? '0' + minute.toString() : minute) +
    utcString.substring(16, 19)

  return localDatetime
}

// export const getDisplayDate = (date) => {
//   const dateSplit = dayjs(date).format('dddd D MMMM HH:mm, YYYY').split(' ')

//   // Day
//   switch (dateSplit[0]) {
//     case 'Monday':
//       dateSplit[0] = 'Måndag'
//       break
//     case 'Tuesday':
//       dateSplit[0] = 'Tisdag'
//       break
//     case 'Wednesday':
//       dateSplit[0] = 'Onsdag'
//       break
//     case 'Thursday':
//       dateSplit[0] = 'Torsdag'
//       break
//     case 'Friday':
//       dateSplit[0] = 'Fredag'
//       break
//     case 'Saturday':
//       dateSplit[0] = 'Lördag'
//       break
//     case 'Sunday':
//       dateSplit[0] = 'Söndag'
//       break
//     default:
//       break
//   }

//   // Month
//   switch (dateSplit[2]) {
//     case 'January':
//       dateSplit[2] = 'januari'
//       break
//     case 'February':
//       dateSplit[2] = 'februari'
//       break
//     case 'March':
//       dateSplit[2] = 'mars'
//       break
//     case 'May':
//       dateSplit[2] = 'maj'
//       break
//     case 'June':
//       dateSplit[2] = 'juni'
//       break
//     case 'July':
//       dateSplit[2] = 'juli'
//       break
//     case 'August':
//       dateSplit[2] = 'augusti'
//       break
//     case 'October':
//       dateSplit[2] = 'oktober'
//       break
//     default:
//       dateSplit[2] = dateSplit[2].toLowerCase()
//       break
//   }

//   return dateSplit.join(' ')
// }

export const getDisplayDate = date => {
  const d = new Date(date)
  const lang = userLang ?? 'se'

  return new Intl.DateTimeFormat(lang, {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    hour: '2-digit',
    minute: '2-digit',
    year: 'numeric'
  }).format(d)
}

/**
 * Get iframe of specific type
 *
 * @param {String} type
 * @param {String} url
 * @returns {Node}
 */
export const getIframe = (type, url) => {
  const container = document.createElement('div')
  container.classList = 'embed-container'
  let ID

  switch (type) {
    case 'YouTube':
      ID = getYouTubeID(url)
      container.innerHTML = `<iframe src='https://www.youtube.com/embed/${ID}' frameborder='0' allowFullscreen allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>`
      break

    case 'Vimeo':
      ID = getVimeoID(url)
      container.innerHTML = `<iframe src='http://player.vimeo.com/video/${ID}' frameborder='0' allowFullscreen allow="fullscreen; picture-in-picture"></iframe>`
      break

    default:
      break
  }

  return container
}

export const getThumbnailURL = (type, url) => {
  let uri = ''

  switch (type) {
    case 'YouTube':
      uri = `https://img.youtube.com/vi/${getYouTubeID(url)}/0.jpg`
      break

    case 'Vimeo':
      // TODO
      break
    default:
      break
  }

  return uri
}

export const containsHTML = str => {
  return /<\/?[a-z][\s\S]*>/i.test(str)
}

const getYouTubeID = url => {
  // Covers v=, vi/, /v/, youtu.be/, /embed/, /shorts/
  const match = url.match(
    /(?:v=|vi\/|\/v\/|youtu\.be\/|\/embed\/|\/shorts\/)([0-9A-Za-z_-]{11})/
  )
  console.log('getYouTubeID', match, url)
  if (match) {
    return match[1]
  }

  // fallback: try to match youtu.be short URL or plain 11-char ID at end
  const fallback = url.match(/([0-9A-Za-z_-]{11})(?:\?|&|$)/)
  if (fallback) {
    return fallback[1]
  }

  return ''
}

const getVimeoID = url => {
  const id = url.match(/(https?:\/\/)?(www\.)?(player\.)?vimeo\.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/)

  return id[5]
}

function resizeImage (file, maxWidth, maxHeight) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)

    reader.onload = function (event) {
      let img = new Image()
      img.src = event.target.result

      img.onload = function () {
        let canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')

        // Calculate the new dimensions
        let width = img.width
        let height = img.height

        if (width > height) {
          if (width > maxWidth) {
            height *= maxWidth / width
            width = maxWidth
          }
        } else {
          if (height > maxHeight) {
            width *= maxHeight / height
            height = maxHeight
          }
        }

        // Set canvas dimensions
        canvas.width = width
        canvas.height = height

        // Draw the image on canvas
        ctx.drawImage(img, 0, 0, width, height)

        // Get the resized image as a data URL
        const dataUrl = canvas.toDataURL('image/jpeg', 1)

        console.log(dataUrl)

        // Resolve the promise with the result
        resolve(dataUrl)

        // Clean up
        img.onload = null
        img.onerror = null
        img = null
        canvas = null
      }

      img.onerror = function (error) {
        reject('Error loading image: ' + error)
        img.onload = null
        img.onerror = null
        img = null
      }
    }

    reader.onerror = function (error) {
      reject('Error reading file: ' + error)
      reader.onload = null
      reader.onerror = null
    }
  })
}
